import { render, staticRenderFns } from "./VersionListContainer.vue?vue&type=template&id=330c274c&scoped=true&"
import script from "./VersionListContainer.vue?vue&type=script&lang=js&"
export * from "./VersionListContainer.vue?vue&type=script&lang=js&"
import style0 from "./VersionListContainer.vue?vue&type=style&index=0&id=330c274c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c274c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
